<template>
    <p>{{ t('inventory.product.import_form.content.info') }}</p>
    <div
        v-for="(row, index) in CONTACT_IMPORT_COLUMN_ROWS"
        :key="index"
        class="flex justify-between space-x-2 whitespace-nowrap px-3 py-2 mb-4 text-xs font-semibold text-black border border-gray-200"
    >
        <span
            v-for="column in row"
            :key="column"
        >
            {{ $t(`contact.contact.import_form.content.file.${column}`) }}
        </span>
    </div>
    <div class="space-y-4 text-xs font-normal text-center">
        <p>{{ t('inventory.product.import_form.content.file.info') }}</p>
        <div class="text-lg text-blue-600">
            <a :href="$t('contact.import_form.example_download_url')">
                <i class="fa-regular fa-file-csv"></i>
                {{ t('inventory.product.import_form.content.file.example.download') }}</a
            >
        </div>
    </div>
    <div :class="$theme('modal.footer.container')">
        <div :class="$theme('modal.footer.button_container')">
            <LoadingButton
                :extra-class-name="$theme('modal.footer.button')"
                :class-name="$theme('button.style.cancel')"
                prevent-default
                @clicked="$emit('close')"
                >{{ t('actions.cancel') }}</LoadingButton
            >
            <LoadingButton
                :extra-class-name="$theme('modal.footer.button')"
                @click="$emit('continue')"
                >{{ t('actions.continue') }}</LoadingButton
            >
        </div>
    </div>
</template>
<script lang="ts" setup>
    import { CONTACT_IMPORT_COLUMN_ROWS } from '~~/app/contact/import/contact-import';

    defineEmits<{
        (e: 'close'): void;
        (e: 'continue'): void;
    }>();

    const { t } = useTranslation();
</script>
